'use strict';

const Mn = require('backbone.marionette');
const Snackbar = require('common/util/snackbar');
const Template = require('communication/ui/comment/template/add.hbs');
const CommentReplyTemplate = require('communication/ui/comment/template/reply.hbs');
const CommentReplyTaskTemplate = require('communication/ui/comment/template/reply-task.hbs');
const MarkdownWriterView = require('common/ui/view/markdown/writer');
const Marked = require('balus/util/marked');
const i18n = require('i18next');

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        commentBody: '.comment-body'
    },
    ui: {
        message: '.comment-message',
        replyTo: '.comment-reply-to',
        replyTask: '.comment-reply-task',
        body: '.comment-body'
    },
    events: {
        'keydown': 'onkeydown',
    },
    childViewTriggers: {
        'blur': 'blur',
        'focus': 'focus',
        'paste:file': 'paste:file'
    },
    marked: Marked(),
    maxRows: 10,

    initialize: function() {
        this._body = this.getOption('tempBody');
        this._marked = this.getOption('marked');
        this._context = this.getOption('context');
        this._bodyRows = null;
    },

    onRender: function() {
        this.writer = new MarkdownWriterView({
            markdown: this._body,
            placeholder: i18n.t(`communication:comment-add.placeholder`),
            rows: this.getOption('rows'),
            hideEditorTab: this.getOption('hideEditorTab'),
            useUploader: this.getOption('useUploader'),
            useBlobSelector: this.getOption('useBlobSelector'),
            blobApi: this.getOption('blobApi'),
            marked: this._marked,
            useWideEditor: false
        });

        this.listenTo(this.writer, 'change', function(body){
            this._body = body;
            if(body) {
                this.triggerMethod('enable:send:button');
            }else{
                this.triggerMethod('disable:send:button');
            }

            this.adjustRows();
        });
        this.showChildView('commentBody', this.writer);

        $.material.init();
    },

    getModelPath: function(model) {
        const key = model.get('key');
        if(key.match(/Diagram/)) {
            return model.path();
        }else if(key.match(/DataContent/)) {
            return model.getContent().path();
        }else if(key.match(/Record/) || key.match(/Relation/)) {
            const projectId = this._context.getProject().id;
            const diagramId = this._context.getDiagram().id;
            return `/projects/${projectId}/diagrams/${diagramId}#/elements/${model.id}`;
        }else {
            return null;
        }
    },

    addContentToComment: function(child) {
        const regExpEscape = function(str) {
            return str.replace(/[()\[\]]/g, '\\$&');
        };
        const key = child.model.get('key');
        const modelPath = this.getModelPath(child.model);
        if(modelPath) {
            const URL = `${location.protocol}//${location.host}${modelPath}`;
            let name ='';
            if(!child.model.get('name')) {
                if(key.match(/Relation/)) {
                    name = i18n.t('button.additional.link-title');
                }else if(key.match(/Record/)) {
                    name = i18n.t('button.additional.node-title');
                }
            }else{
                name = child.model.get('name');
            }
            const linkForComment = `[${regExpEscape(name)}](${URL})`;
            this.appendCommentBody(linkForComment);

        }else {
            Snackbar.error(i18n.t('button.additional.error'));
        }
        this.triggerMethod('comment:form:resized');
    },

    updateRows: function(rows) {
        this.writer.updateRows(rows);
    },

    appendCommentBody: function(str) {
        this.writer.append(str);
    },

    getComment: function() {
        let replyToID = null;
        if(this._replyTo) {
            replyToID = this._replyTo.getReplyTo() ? this._replyTo.getReplyTo() : this._replyTo.id;
        }
        const comment = {
            body: this._body,
            replyTo: replyToID
        };

        return comment;
    },

    getReplyTo: function() {
        return this._replyTo;
    },

    setReplyTo: function(comment) {
        this._replyTo = comment;
        comment.activate();

        let j = comment.toJSON();
        j.isReplyToThread = comment.getReplyComments().length > 0 || comment.getReplyTo();
        this.ui.replyTo.html(CommentReplyTemplate(j));
        this.$('.comment-reply-remove').on('click', () => {
            this.removeReplyTo();
        });
    },

    setReplyTask: function(task) {
        this._replyTask = task;

        let j = task.toJSON();
        this.ui.replyTask.html(CommentReplyTaskTemplate(j));
        this.$('.comment-reply-task-remove').on('click', () => {
            this.removeReplyTask();
        });
    },

    removeReplyTo: function() {
        if(this._replyTo) {
            this._replyTo.deactivate();
            this._replyTo = null;
        }
        this.ui.replyTo.html('');
        this.triggerMethod('removeReply');
    },

    removeReplyTask: function() {
        this._replyTask = null;
        this.ui.replyTask.html('');
    },

    cleanup: function() {
        this._body = '';
        this.writer.clear();
        this.triggerMethod('disable:send:button');
    },

    disabled: function() {
        this.writer.disabled();
    },

    enabled: function() {
        this.writer.enabled();
    },

    showError: function(alert) {
        Snackbar.error(alert);
    },

    onkeydown: function(e) {
        if(this._body) {
            if ((e.ctrlKey && e.keyCode == 13) || (e.metaKey && e.keyCode == 13)) { // Ctrl or Command + Enter
                this.triggerMethod('comment');
            }
        }
    },

    getCommentRows: function() {
        return this.writer.getTextRows();
    },

    adjustRows: function() {
        const maxRows = this.getOption('maxRows');
        let rows = this.getCommentRows();
        if(rows > maxRows) {
            rows = maxRows;
        }
        if (this._bodyRows === rows) {
            return;
        }

        this.updateRows(rows);
        this._bodyRows = rows;
        this.triggerMethod('comment:form:resized');
    }
});



// WEBPACK FOOTER //
// ./communication/ui/comment/view/add.js